var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-wait-component',{attrs:{"for":_vm.waitsFor}},[_c('gd-loader',{attrs:{"slot":"waiting"},slot:"waiting"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }